import { render, staticRenderFns } from "./ProductIdListForm.vue?vue&type=template&id=7fc52ddd&scoped=true"
import script from "./ProductIdListForm.vue?vue&type=script&lang=js"
export * from "./ProductIdListForm.vue?vue&type=script&lang=js"
import style0 from "./ProductIdListForm.vue?vue&type=style&index=0&id=7fc52ddd&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fc52ddd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7fc52ddd')) {
      api.createRecord('7fc52ddd', component.options)
    } else {
      api.reload('7fc52ddd', component.options)
    }
    module.hot.accept("./ProductIdListForm.vue?vue&type=template&id=7fc52ddd&scoped=true", function () {
      api.rerender('7fc52ddd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/product-id-list/ProductIdListForm.vue"
export default component.exports